import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleRatingFilter } from '../../actions/filters';
import { loadReviews } from '../../actions/reviews/loadReviews';
import { RatingsFilter } from '../../components/RatingsFilter';
import { getActiveTagFiltersValue, getAvailableRatings } from '../../selectors/filters';
import { useApplicationContext } from '../../utils/applicationContext';
import { getNewbuildingRating } from '../../selectors/newbuildingInfo';
import { tracFilterAnalyticClick } from './analytics/reactionAnalytic';
import { getIsQuestionTab } from '../../selectors/tabs';

export function RatingsFilterContainer() {
  const dispatch = useDispatch();
  const availableRatings = useSelector(getAvailableRatings);
  const context = useApplicationContext();
  const siteType = context.custom.deviceType;
  const rating = useSelector(getNewbuildingRating);
  const tag = useSelector(getActiveTagFiltersValue);
  const isQuestionTab = useSelector(getIsQuestionTab);

  const onFilterClick = React.useCallback(
    (reviewRate: number) => {
      const page = {
        offerType: 'JK',
        pageType: 'ReviewsJK',
        siteType,
        extra: {
          rating,
          filter_rating: reviewRate,
          filter_tag: tag,
        },
      };
      tracFilterAnalyticClick({ page });
      dispatch(toggleRatingFilter(reviewRate));
      dispatch(loadReviews());
    },
    [dispatch, tag],
  );

  if (!availableRatings.length) {
    return null;
  }

  if (isQuestionTab) {
    return null;
  }

  return <RatingsFilter availableRatings={availableRatings} onFilterClick={onFilterClick} />;
}
